<template>
    <el-dialog
    title="实训记录"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    width="120rem">
    <div class="content-box">
        <div class="top-content-box">
            <p>{{ detail.tenantId==tenantId?detail.userName:(detail.userName?(detail.userName[0]+'**'):'') }}</p>
            <p>{{ detail.schoolName }}</p>
            <div class="hr"></div>
            <div class="top-item" style="margin-left: 1rem;">
                <p>实训总时长</p>
                <p>{{ detail.trainingTime||'/' }}</p>
            </div>
            <div class="top-item" style="margin-left: 3.5rem;">
                <p>实训次数</p>
                <p>{{ detail.trainingCount }}</p>
            </div>
            <div class="top-item" style="margin-left: 3.5rem;">
                <p>完成度</p>
                <p>{{ detail.finishingRate+'%' }}</p>
            </div>
        </div>
        <div class="table-content-box">
            <train-record-table  :userId="detail.userId" ref="train_record_table"></train-record-table>
        </div>
    </div>
    </el-dialog>
</template>

<script>
import TrainRecordTable from '../../personCenter/trainRecord/TrainRecordTable.vue';
    export default {
  components: { TrainRecordTable },
        props:['softwareItem'],
        data(){
            return {
                dialogVisible:false,
                detail:{},
            }
        },
        computed:{
            tenantId(){
                return this.$store.state.user.userInfo.tenantId;
            }
        },
        methods:{
            // changePageSize(e){
            //     this.pages.size=e;
            //     this.pages.current=1;
            //     this.pageQuerySoftwareTrainingDetail();
            // },
            /**查看记录列表 */
            viewTrainList(){
                this.$nextTick(()=>{
                    let dom=this.$refs.train_record_table;
                    if(dom){
                        dom.softwareCode=this.softwareItem.softwareCode;
                        dom.pageQuerySoftwareDrillList();
                        dom.title=this.softwareItem.softwareName;
                    }
                })
            },
            // changeCurrentPage(e){
            //     this.pages.current=e;
            //     this.pageQuerySoftwareTrainingDetail();
            // },
            // pageQuerySoftwareTrainingDetail(callback){
            //     let params={
            //     "current": this.pages.current,
            //     "size": this.pages.size,
            //     "softwareCode": this.softwareItem.softwareCode,
            //     "userId": this.detail.userId
            //     }
            //     PageQuerySoftwareTrainingDetail(params).then(res=>{
            //         if(res.code==200){
            //             this.tableData=res.data.records;
            //             this.pages.total=res.data.total;
            //             typeof callback=='function'&&callback();
            //         }
            //     })
            // }
        }
    }
</script>

<style lang="less" scoped>
/deep/.el-dialog__title{
    font-size: 16px;
    font-weight: 700;
    color: #334681;
}
/deep/.el-dialog{
    border-radius: 1rem;
}
.top-content-box{
    height: 6rem;
    background-color: #F3F7FC;
    display: flex;
    align-items: center;
    padding: 0 3.5rem;
    &> :nth-child(1){
        font-weight: 700;
        font-size: 16px;
    }
    &> :nth-child(2){
        margin-left: 1.5rem;
    }
    .hr{
        margin: 0 1.7rem;
        width: 1px;
        height: 2rem;
        background-color: #C2C7D9;
    }
}
.top-item{
    display: flex;
    &> :nth-child(2){
        margin-left: 1rem;
        color: var(--blue);
    }
}
.table-content-box{
    border-top:1px solid #EDF3F9;
    margin-top: 3rem;
    padding-top: 2.7rem;
    .box{
        margin-top: 3rem;
        height: 50rem;
    }
}
.table-title{
    font-weight: 700;
    margin-left: 3.5rem;
}
/deep/.el-table--border th {
    background-color: #F3F7FC !important;
}
/deep/.el-table--border, .el-table--group{
    border: none !important;
}
/deep/.el-table--border::after, .el-table--group::after{
    width: 0 !important;
}
/deep/.el-table{
    border-radius: 0 !important;
}
</style>